import http from "src/lt-module/utils/http.js";

export class DinnerService {
  static async savePreparedProducts(productSaleIds = [], done = true) {
    return (
      await http.post("api/service/prepared-products-group", {
        list: productSaleIds,
        done: done
      })
    ).data;
  }

  static async getLastCashRegister(cashRegisterId) {
    return (
      await http.get("api/custom/lastbox", {
        params: { cashRegisterId }
      })
    ).data;
  }

  static async savePreparedProduct(reg) {
    if (reg.id) {
      return (await http.put(`api/service/prepared-products/${reg.id}`, reg))
        .data;
    } else {
      return (await http.post("api/service/prepared-products", reg)).data;
    }
  }

  static async getLastStock() {
    return (await http.get("api/custom/logistic")).data;
  }

  static async saveLogisticHistory(history) {
    return (await http.post("api/custom/logistic", history)).data;
  }

  static async deleteOutput(outputId) {
    return (await http.delete(`api/admin/cash-register/outputs/${outputId}`))
      .data;
  }
  static async deleteInput(inputId) {
    return (await http.delete(`api/admin/cash-register/inputs/${inputId}`))
      .data;
  }

  static async openCashBox() {
    return (await http.post("api/admin/cash-registers/new")).data;
  }

  static async getCashBoxId() {
    return (await http.get("api/admin/id-my-cashregister")).data;
  }

  static async getCashRegister(cashRegisterId) {
    return (await http.get(`api/admin/cash-registers/${cashRegisterId}`)).data;
  }

  static async getCashBox() {
    let cashRegisterId = await this.getCashBoxId();
    if (cashRegisterId) {
      return await this.getCashRegister(cashRegisterId);
    } else {
      throw "you don't have cash register";
      // return undefined;
    }
  }

  static async getProducts(params) {
    return (await http.get("api/store/products", { params })).data;
  }

  static async makeClientRequest() {
    // return (await http.post("api/shared/delivery-products", reg)).data;
    return new Promise((rsv) => rsv());
  }

  static async makeSaleRequest(reg) {
    return (await http.post("api/service/prepared-sale", reg)).data;
  }

  static async getDeliveryPoints() {
    // return (await http.get("api/shared/products", { params })).data;
    return {
      list: [
        { id: 1, name: "Frente al estadio", lat: 24.53453, lng: -35.345234 },
        { id: 2, name: "Salcedo", lat: 43.31, lng: 56.44 }
      ],
      home: 1
    };
  }

  static async getReport(date, entity_id) {
    return (
      await http.get(`api/service/prepare-report`, {
        params: {
          date,
          entity_id
        }
      })
    ).data;
  }

  static async closeBox() {
    return (await http.put("api/admin/cash-registers/close")).data;
  }

  static async getChicken(date, entityId) {
    return (
      await http.get("api/service/chicken/last", {
        params: {
          date,
          entity_id: entityId
        }
      })
    ).data;
  }

  static async saveChicken(date, entityId, quantity) {
    return (
      await http.post("api/service/chicken/save", {
        date,
        entity_id: entityId,
        quantity
      })
    ).data;
  }

  static async getKitchenWorks(params) {
    return (await http.get("api/service/prepared-products", { params })).data;
  }
}
